var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"fixed","width":"100%"}},[(_vm.width === 'xs')?_c('phone-navigation',{attrs:{"links":_vm.links}}):_c('standard-navigation',{attrs:{"links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }